import { Drawer } from 'antd';

export default function CheckpointDrawer({ checkpoint, open, onClose }) {
  if (!checkpoint) return null;
  const locked = checkpoint.state === 'locked';

  return (
    <Drawer
      title={checkpoint.name}
      placement="bottom"
      height="75vh"
      open={open}
      onClose={onClose}
      className="checkpoint-drawer"
    >
      <div className="checkpoint-drawer-hero">
        {checkpoint.imageUrl ? <img alt="" src={checkpoint.imageUrl} /> : <span>{checkpoint.location}</span>}
      </div>
      <p className="checkpoint-location">{checkpoint.location}</p>
      <p>{locked ? 'Mở khoá khi đội hình chạm tới chặng này.' : checkpoint.description}</p>
      <div className="checkpoint-stats">
        <span>{checkpoint.distanceKm} km</span>
        <span>{checkpoint.state}</span>
        <span>{checkpoint.medalName}</span>
      </div>
      {/* <button type="button" className="checkpoint-streetview" disabled={locked}>
        Xem Street View
      </button> */}
    </Drawer>
  );
}
